import { Box, ListItem, OrderedList, VStack } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { Activity } from './Activity';
import { Earnings } from './Earnings';
import { Fees } from './Fees';
import { Header } from './Header';
import { Holdings } from './Holdings';
import { Rewards } from './Rewards';

export const StatementPage: React.FC = () => {
  return (
    <>
      <style type="text/css" media="print">
        {` @page {
        size: A4;
        size: portrait;
      }

      .statement-table-header {
        font-size: 10px!important;
      }
      .statement {
        font-size:10px!important;
      }
    `}
      </style>
      <style type="text/css">
        {` .statement-table-header {
          font-size: 12px;
        }
        
        .statement {
          font-size:12px
        }
        `}
      </style>
      <Box className="statement" padding="30px" margin="auto" maxW="1000px" minW="725px" h="full">
        <Header />
        <VStack mt="50px" gap={'50px'} w="full">
          <Holdings />
          <Earnings />
          <Rewards />
          <Activity />
          <Fees />
          <Box mt="39px" style={{ breakInside: 'avoid' }}>
            <TextBlock fontSize="inherit">
              Investments in Concreit funds and homes are inherently long-term, illiquid investments. There is presently
              no market for these shares and the redemption plans (if any) for the funds may be suspended at any time,
              without notice, such as during economic crises.
            </TextBlock>
          </Box>
          <Box style={{ breakInside: 'avoid' }}>
            <TextBlock fontSize="inherit" fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
              Footnotes
            </TextBlock>
            <OrderedList role="" listStyleType={'decimal'} marginLeft="10px">
              <ListItem style={{ marginTop: '10px', paddingLeft: '5px' }}>
                The number of shares you currently own of this investment at the end of this period.{' '}
              </ListItem>
              <ListItem style={{ marginTop: '10px', paddingLeft: '5px' }}>
                For investments in Home Shares™, the value is determined by either the Net Asset Value (NAV) per share
                on the date of the statement or the price per share on that date if the NAV hasn't started being
                reported yet. It's important to note, though, that this value doesn't follow the fair value rules set by
                Generally Accepted Accounting Principles (GAAP). So, the NAV or price per share might not reflect the
                actual price a shareholder could get for their shares in today's market.
              </ListItem>
              <ListItem style={{ marginTop: '10px', paddingLeft: '5px' }}>
                This represents the number of shares you own multiplied by the estimated value per share.
              </ListItem>
            </OrderedList>
          </Box>
          <Box style={{ breakInside: 'avoid' }}>
            <TextBlock fontSize="inherit" weight="bold">
              Disclosures
            </TextBlock>
            <TextBlock fontSize="inherit" mt="10px">
              Concreit Inc. owns this website and certain apps (the "Services"). Concreit Fund Management LLC
              ("Concreit"), an investment adviser registered with the Securities and Exchange Commission (“SEC”),
              operates the Services. By using the Services, you accept our Terms of Service and Privacy Policy.
              Concreit's investment advisory services are available only to residents of the United States in
              jurisdictions where Concreit is registered. Nothing on this website should be considered an offer,
              solicitation of an offer, or advice to buy or sell securities. Past performance is no guarantee of future
              results. Any historical returns, expected returns [or probability projections] are hypothetical in nature
              and may not reflect actual future performance. Account holdings are for illustrative purposes only and are
              not investment recommendations. The content on this website is for informational purposes only and does
              not constitute a comprehensive description of Concreit’s investment advisory services.
            </TextBlock>
            <TextBlock fontSize="inherit" mt="10px">
              Refer to Concreit’s Disclosure Brochure for more information. Certain investments are not suitable for all
              investors. Before investing, consider your investment objectives and Concreit’s fees. The rate of return
              on investments can vary widely over time, especially for long term investments. Investment losses are
              possible, including the potential loss of all amounts invested. For more information, see our disclosures.
              Contact: 1201 3rd Ave, Suite 2200, Seattle, WA 98101.
            </TextBlock>
            <TextBlock fontSize="inherit" mt="10px">
              Information provided by Concreit Support is for informational and general educational purposes only and is
              not investment or financial advice. Neither Concreit nor any of its affiliates provide tax advice and do
              not represent in any manner that the outcomes described herein will result in any particular tax
              consequence. Prospective investors should confer with their personal tax advisors regarding the tax
              consequences based on their particular circumstances. Neither Concreit nor any of its affiliates assume
              responsibility for the tax consequences for any investor of any investment.
            </TextBlock>
          </Box>
        </VStack>
      </Box>
    </>
  );
};
